//Sections
export const TRANSACTION_DETAILS = "transactionDetails";
export const BUILDING_DETAILS = "buildingDetails";
export const COMMERCIAL_TERMS = "commercialTerms";
export const RIGHTS_AND_OPTIONS = "rightsAndOptions";
export const CUSTOM_TERMS = "customTerms";

export const LAYOUT_SECTIONS = [
  TRANSACTION_DETAILS,
  BUILDING_DETAILS,
  COMMERCIAL_TERMS,
  RIGHTS_AND_OPTIONS,
  CUSTOM_TERMS,
];
